export enum PerformerAppPath {
  MyJobs = "jobs?tab=myjobs",
  AllPaid = "jobs?tab=allpaid",
  TapeRequests = "jobs?tab=taperequests",
}

export const SMART_BANNER_CONTAINER_ID = "smart-banner-container";

export const appStoreFallbackTimeDelta = 2500;

export const dismissedTimestampStoreKey = "smartBannerDismissedTimestamp";
